import { FC } from 'react';
import operationTypes from 'constants/operationTypes';

import DividendsOperationTableHeader from '../components/DividendsOperation/DividendsOperationTableHeader';
import ContributionOperationTableHeader from '../components/ContributionOperation/ContributionOperationTableHeader';
import ReclassificationOperationTableHeader from '../components/ReclassificationOperation/ReclassificationOperationTableHeader';
import SplitOperationTableHeader from '../components/SplitOperation/SplitOperationTableHeader';
import CapitalVariationOperationTableHeader from '../components/CapitalVariationOperation/CapitalVariationOperationTableHeader';
import SharesTransferOperationTableHeader from '../components/SharesTransferOperation/SharesTransferOperationTableHeader';

export const operationTableHeaderMap: Record<string, FC> = {
  [operationTypes.CONSTITUTION]: CapitalVariationOperationTableHeader,
  [operationTypes.CAPITAL_INCREASE]: CapitalVariationOperationTableHeader,
  [operationTypes.CAPITAL_DECREASE]: CapitalVariationOperationTableHeader,
  [operationTypes.SELL_PARTICIPATION]: SharesTransferOperationTableHeader,
  [operationTypes.HERITAGE]: SharesTransferOperationTableHeader,
  [operationTypes.DONATION]: SharesTransferOperationTableHeader,
  [operationTypes.ENDORSEMENT]: SharesTransferOperationTableHeader,
  [operationTypes.TRANSMISSION]: SharesTransferOperationTableHeader,
  [operationTypes.SPLIT]: SplitOperationTableHeader,
  [operationTypes.RECLASSIFICATION]: ReclassificationOperationTableHeader,
  [operationTypes.DIVIDENDS_DISTRIBUTION]: DividendsOperationTableHeader,
  [operationTypes.CONTRIBUTION]: ContributionOperationTableHeader,
};
